var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHamburger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 17h22a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2M1 1h22a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2m0 8h22a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2"
})));
export default SvgHamburger;